const getNewCaptcha = () => {
    $.get("GetNewCaptcha")
        .then((data) => {
            if (data) {
                const { srcImage } = data;
                $(".captcha-image").attr("src", srcImage);
                $(".captcha-result").val("");
                $(".captcha-section").removeClass("hidden");
            } else {
                throw Error(`invalid captchaData => ${data}`);
            }
        });
};

$(function () {
    getNewCaptcha();
    $(".renew-captcha").click(getNewCaptcha);
});
